import { render, staticRenderFns } from "./ImportarTransacoesEmpenhoSIAF.vue?vue&type=template&id=7b645969&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./ImportarTransacoesEmpenhoSIAF.vue?vue&type=style&index=0&id=7b645969&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b645969",
  null
  
)

export default component.exports